/*
*
* File per Count Down 
*
*/

// Imports
//--------------------------------------------------------------------//
import jquerycountdown from 'jquery-countdown';


// Init all Select
//--------------------------------------------------------------------//

const countdown = () => {
    const countdownElements = $("[data-countdown]");

    if (countdownElements.length === 0) {
        return
    } else {
    countdownElements.each(function () {
        var $this = $(this),
        finalDate = $(this).data("countdown");
        $this.countdown(finalDate, function (event) {
        $this.html(
            event.strftime(
            "<div>-</div> <div>%D <span>dy</span></div> <div>%H<span>hr</span></div> <div>%M<span>mn</span></div> <div>%S<span>sc</span></div>"
            )
        );
        });
    });
    } 
}

export default countdown
